import { ChangeDetectionStrategy, Component, inject, model, output, signal } from '@angular/core';
import { DocumentiService } from 'src/app/core/documenti.service';
import { DocumentiSearchDocRow, DocumentiSearchRequest, DocumentiSearchResponse } from '../models/documento-search.model';
import { DocumentiListColumnNames } from './documenti-list/documenti-list.model';

@Component({
  selector: 'app-riferimenti-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-dialog header="Seleziona Riferimenti" [(visible)]="visible" [styleClass]="'riferimenti-dialog'"
      [modal]="true" (onHide)="hideDialog()">
      <div class="card grid">
        <div class="col-10">
          <input pInputText type="text" [(ngModel)]="protocollo" placeholder="Ricerca protocollo" (keyup.enter)="searchRiferimenti()">
        </div>
        <div class="col-2">
          <p-button [styleClass]="'button-class'" icon="fas fa-search" label="" (onClick)="searchRiferimenti()"
            novalidate title="Cerca Riferimenti"></p-button>
        </div>
      </div>
      <div>
        @if(riferimentiSearchResponse(); as riferimentiSearchResponse) {
          @if(riferimentiSearchResponse.results && riferimentiSearchResponse.results.length > 0) {
          <app-documenti-list [data]="riferimentiSearchResponse" [activeColumns]="riferimentiColumns" [allowPosizioneHierarchy]="false" [allowSelection]="true"
            (updateRequestAndSearch)="updateRequestAndSearchRiferimenti($event)" (rowSelected)="rowSelected($event)" />
          }
        }
      </div>
      <p-footer>
        <button pButton type="button" icon="pi pi-times" label="Annulla" (click)="hideDialog()"
          class="p-button-secondary"></button>
        <button pButton type="button" icon="pi pi-check" label="Aggiungi riferimento" (click)="addLink()"
          [disabled]="!selectedDocument()"></button>
      </p-footer>
    </p-dialog>
    `
})

export class RiferimentiDialogComponent {
  visible = model.required<boolean>();
  hide = output();
  confirm = output<number>();

  public protocollo = '';
  public selectedDocument = signal<DocumentiSearchDocRow | null>(null);
  public riferimentiSearchResponse = signal<DocumentiSearchResponse>({ originalRequest: { pageFirstRow: 0, pageSize: 5, sortField: 'Protocollo', sortOrder: 1 } } as DocumentiSearchResponse);
  public riferimentiColumns: DocumentiListColumnNames = ['PosizioneId', 'Protocollo', 'DataDocumento', 'Oggetto', 'Arrivo', 'Mittente', 'Destinatari'];

  private documentiService = inject(DocumentiService);

  searchRiferimenti(): void {
    this.updateRequestAndSearchRiferimenti({ filters: { protocolloOrProtocolloMittente: this.protocollo } } as DocumentiSearchRequest);
  }

  updateRequestAndSearchRiferimenti(request: DocumentiSearchRequest | null): void {
    const mergedRequest = { ...this.riferimentiSearchResponse().originalRequest, ...request } as DocumentiSearchRequest;
    this.documentiService.search(mergedRequest).subscribe(response => this.riferimentiSearchResponse.set(response));
  }

  rowSelected(row: DocumentiSearchDocRow): void {
    this.selectedDocument.set(row);
  }

  hideDialog(): void {
    this.protocollo = '';
    this.selectedDocument.set(null);
    this.riferimentiSearchResponse.set({ originalRequest: { pageFirstRow: 0, pageSize: 5, sortField: 'Protocollo', sortOrder: 1 } } as DocumentiSearchResponse);
    this.hide.emit();
  }

  addLink(): void {
    const selectedDocument = this.selectedDocument();
    if (!selectedDocument) return;

    this.confirm.emit(selectedDocument.documentoId);
    this.hideDialog();
  }
}
